import React from "react";
import AppRouter from "./AppRouter";

import "../styles/App.css";
import "../styles/kvaicons.css";

export default class App extends React.Component {
  render() {
    return <AppRouter />;
  }
}
